import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import {HeroModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./WebstoreHeader.module.scss"

type Props = {
	data: HeroModuleType
}

const WebstoreHeader = (props: Props) => {
	return (
		<FullWidthHeaderAdvanced
			className={styles.container}
			data={props.data}
			subtitleStyle={`${styles.subtitle}`}
			textColor={"black"}
			titleStyle={`${styles.title}`}
			titleWithoutHtml={false}
		/>
	)
}

export default WebstoreHeader
